module.exports = __webpack_public_path__ + "img/lock.87640786.svg";